import { Card } from "@amzn/stencil-react-components/card";
import { Col, Row } from "@amzn/stencil-react-components/layout";
import { Status, StatusIndicator } from "@amzn/stencil-react-components/status-indicator";
import { Text } from "@amzn/stencil-react-components/text";
import { getString } from "common/uistringlabels/uiStringUtils";
import React, { FC } from "react";

export interface UseCaseImpact {
  before: string;
  after: string;
  keyImprovements?: string[];
}

export interface UseCaseImpactPanelProps {
  impact: UseCaseImpact;
}

export const UseCaseImpactPanel: FC<UseCaseImpactPanelProps> = ({ impact }) => (
  <Col gridGap="dimensions.spacing.300">
    <Row gridGap="dimensions.spacing.300">
      <Card flex={1} padding="dimensions.spacing.300">
        <Col gridGap="dimensions.spacing.200">
          <StatusIndicator status={Status.Negative} messageText={getString("useCases.impact.before")} />
          <Text fontSize="T200">{impact.before}</Text>
        </Col>
      </Card>
      <Card flex={1} padding="dimensions.spacing.300">
        <Col gridGap="dimensions.spacing.200">
          <StatusIndicator status={Status.Positive} messageText={getString("useCases.impact.after")} />
          <Text fontSize="T200">{impact.after}</Text>
        </Col>
      </Card>
    </Row>
    {impact.keyImprovements && impact.keyImprovements.length > 0 && (
      <Col gridGap="dimensions.spacing.200">
        <Text fontSize="T200" fontWeight="bold">
          {getString("useCases.impact.keyImprovements")}
        </Text>
        {impact.keyImprovements.map((item, i) => (
          <StatusIndicator key={i} status={Status.Positive} messageText={item} />
        ))}
      </Col>
    )}
  </Col>
);
